<script lang="tsx">
  import { type PropType } from "vue";
  import NavPopoverPane from "./NavPopoverPane.vue";
  import type { MenuTreeType } from "@/gql/graphql";

  export default {
    components: { NavPopoverPane },
    props: {
      tree: {
        type: Object as PropType<MenuTreeType>,
        required: true,
      },
    },
    data(this) { return {
      crumbs: [this.tree] as MenuTreeType[],
    }},
    computed: {
      current() { return this.$data.crumbs[this.crumbs.length - 1]; },
      current_children() { return this.$data.crumbs[this.crumbs.length - 1].children!; },
    },
    emits: {
      close() { return true; },
    },
    methods: {
      push(i: number) {
        this.$data.crumbs.push(this.current_children![i]!);
      },
      pop() {
        if (this.$data.crumbs.length > 1) {
          this.$data.crumbs.pop();
        } else {
          this.$emit("close");
        }
      },
    }
  };
</script>

<template>
  <div class="slider-container">
    <div class="slider">
      <NavPopoverPane v-for="(crumb, i) in crumbs"
        class="pane" :inert="i !== crumbs.length - 1"
        :tree="crumb" :button="i > 0 ? 'back' : 'close'"
        @select="(i: number) => push(i)" @back="pop()"/>
        <!-- todo: set visibility:none to prevent tabbing around -->
    </div>
  </div>
</template>

<style lang="less" scoped>
// @import (reference) "@/style/main.less";

.slider-container {
  // background-color: var(--color-navbar-bg);
  // border: 1px solid var(--color-border);
  // border-radius: var(--spacing-radius);
  overflow: hidden;

  & > .slider {
    display: flex;
    min-width: 25em;
    height: max-content;
    width: 25em;
    overflow-x: visible;

    position: relative;
    left: calc(~"-25em * v-bind(crumbs.length - 1)");
    transition: left var(--p-transition-duration) ease-in-out;
    // todo: height isn't animated
    // for animating height, check out interpolate-size css WD
  }
}

.pane {
  flex: 1 0 25em;
  width: 25em;
}
</style>
